import React, { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'

// [긴급 복구 지원망] 리액트 바깥에서 터지는 글로벌 에러를 강제로 잡아 화면에 뿌립니다.
window.addEventListener('error', (event) => {
  document.body.innerHTML = `<div style="padding:40px; background:#222; color:#ff5555; font-family:monospace; line-height: 1.5;"><h2>🚨 전역 엔진 충돌 (Window Error)</h2><h3>${event.message}</h3><p style="font-size: 14px;">File: ${event.filename}<br/>Line: ${event.lineno} / Col: ${event.colno}</p></div>`;
});
window.addEventListener('unhandledrejection', (event) => {
  document.body.innerHTML = `<div style="padding:40px; background:#222; color:#ffbd1f; font-family:monospace; line-height: 1.5;"><h2>🚨 비동기 거부 (Promise Unhandled)</h2><h3>${event.reason}</h3></div>`;
});

class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error("Global Error Caught: ", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '40px', background: '#ffebee', color: '#c62828', height: '100vh', fontFamily: 'sans-serif' }}>
          <h1 style={{ fontSize: '32px', borderBottom: '2px solid #ef5350', paddingBottom: '10px' }}>🛑 치명적인 화면 렌더링 오류 발생!</h1>
          <p style={{ fontSize: '18px', fontWeight: 'bold' }}>아래의 에러 메시지를 복사해서 개발자(AI)에게 전달해주세요:</p>
          <pre style={{ background: '#b71c1c', color: '#fff', padding: '20px', borderRadius: '8px', overflowX: 'auto', fontSize: '14px', lineHeight: '1.5' }}>
            {this.state.error && this.state.error.toString()}
            {"\n\n=== COMPONENT STACK ===\n"}
            {this.state.errorInfo && this.state.errorInfo.componentStack}
          </pre>
          <button onClick={() => window.location.reload()} style={{ marginTop: '20px', padding: '10px 20px', fontSize: '16px', cursor: 'pointer', background: '#e53935', color: '#fff', border: 'none', borderRadius: '6px' }}>새로고침 시도</button>
        </div>
      );
    }
    return this.props.children;
  }
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <GlobalErrorBoundary>
      <App />
    </GlobalErrorBoundary>
  </StrictMode>,
)
